import { KeyTextType } from 'types';
import {
  KeyTextAsset,
  KeyTextAssetIds,
  KeyTextAssetType,
  VideoTemplateStateContent,
} from '../types';

function createStateFromKeyTextAssets(
  keyTextAssetIds: KeyTextAssetIds,
  type: KeyTextAssetType,
): { [k in KeyTextType]?: KeyTextAsset } {
  return Object.keys(keyTextAssetIds).reduce((acc, textAssetType) => {
    acc[textAssetType] = {
      id: keyTextAssetIds[textAssetType],
      type,
    };
    return acc;
  }, {} as any);
}

export function getKeyTextAssets(
  overlayAssets: KeyTextAssetIds,
  slideTextAssets: KeyTextAssetIds,
): Pick<VideoTemplateStateContent, KeyTextType> {
  const keyOverlayAssets = createStateFromKeyTextAssets(
    overlayAssets,
    'textOverlay',
  );
  const keySlideTextAssets = createStateFromKeyTextAssets(
    slideTextAssets,
    'slideEffectText',
  );

  return { ...keyOverlayAssets, ...keySlideTextAssets };
}
